export default "__VITE_ASSET__DfLN1bzs__"